import * as Yup from "yup";
import i18next from "i18next";

const phoneRegExp = /^[0-9]{10,15}$/;

export const UserSignupSchema = () => Yup.object({

    first_name: Yup.string().required(i18next.t('customer.error_fname')),
    last_name: Yup.string().required(i18next.t('customer.error_lname')),
    gender: Yup.string().required(i18next.t('customer.error_gender')),
    dob: Yup.string().required(i18next.t('customer.error_dob')),
    email: Yup.string().email().required(i18next.t('customer.error_email')),
    password: Yup.string().required(i18next.t('customer.error_password')),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], i18next.t('customer.error_pass_match'))
        .required(i18next.t('customer.error_confirm_password')),
    mobile_number: Yup.string().matches(phoneRegExp, i18next.t('customer.error_invalid_mobile')).required(i18next.t('customer.error_mobile')),
    profile: Yup.mixed().notRequired(i18next.t('customer.error_profile')),

});